import "./dataTableTicketSite.scss";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    setField,
    resetFilters,
    setPage,
    setPageSize,
    fetchSearchData,
} from "../../slice/searchSlice";
import {useEffect, useMemo} from "react";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import debounce from "lodash.debounce";
import useRegions from "../../hooks/useRegions";

const DatatableTicketSite = ({ columns }) => {
    const location = useLocation();
    const path = location.pathname.split("/")[1];

    const dispatch = useDispatch();
    const search = useSelector((state) => state.search);
    const { regions } = useRegions();

    // Fetch data setiap ada perubahan filter atau pagination
    const debouncedFetch = useMemo(
        () =>
            debounce((params) => {
                dispatch(fetchSearchData({ path, params }));
            }, 500), // delay 500ms
        [dispatch, path]
    );

    useEffect(() => {
        debouncedFetch(search);

        // Cancel debounce on unmount / change
        return () => debouncedFetch.cancel();
    }, [
        search.page,
        search.pageSize,
        search.query,
        search.queryTicketId,
        search.queryStatusId,
        search.queryCustomer,
        search.queryMonth,
        search.queryYear,
        search.queryVendorId,
        search.regionId,
        search.startDate,
        search.endDate,
        search.order,
        debouncedFetch,
    ]);

    const handleSelectRegionID = (e) => {
        dispatch(
            setField({
                name: "regionId",
                value: e.target.value,
            })
        );
    };

    const actionColumn = [
        {
            field: "action_k",
            headerName: "Action",
            width: 600,
            renderCell: (params) => {
                return (
                    <div className="cellAction">
                        <Link to={`/ticketsite/${params.row.id}`} style={{textDecoration: "none"}}>
                            <div className="viewButton">View</div>
                        </Link>
                        <Link to={`/ticketsite/update/${params.row.id}`} style={{textDecoration: "none"}}>
                            <div
                                className="updateButton"
                            >
                                Update Ticket Local Site
                            </div>
                        </Link>
                        <Link to={`/ticketsite/update/time/${params.row.id}`} style={{textDecoration: "none"}}>
                            <div
                                className="updateTimeButton"
                            >
                                Update Local Site Time
                            </div>
                        </Link>


                    </div>
                );
            },
        },
    ];

    return (
        <div className="datatable">
            <div className="datatableTitle">{path.toUpperCase()}</div>

            {/* SEARCH FILTER UI */}
            <div className="column-search">
                <div className="search">

                    <input
                        type="text"
                        placeholder="TicketId"
                        value={search.queryTicketId}
                        onChange={(e) => dispatch(setField({name: "queryTicketId", value: e.target.value}))}
                    />
                    <SearchOutlinedIcon/>

                    <input
                        type="text"
                        placeholder="VendorId"
                        value={search.queryVendorId}
                        onChange={(e) => dispatch(setField({name: "queryVendorId", value: e.target.value}))}
                    />
                </div>

                <div className="search">
                    <input
                        type="text"
                        placeholder="StatusID"
                        value={search.queryStatusId}
                        onChange={(e) =>
                            dispatch(setField({name: "queryStatusId", value: e.target.value}))
                        }
                    />
                    <SearchOutlinedIcon/>

                    <input
                        type="text"
                        placeholder="Segment Cust"
                        value={search.queryCustomer}
                        onChange={(e) =>
                            dispatch(setField({name: "queryCustomer", value: e.target.value}))
                        }
                    />
                </div>

                <div className="search">
                    <input
                        type="text"
                        placeholder="Month"
                        value={search.queryMonth}
                        onChange={(e) => dispatch(setField({name: "queryMonth", value: e.target.value}))}
                    />
                    <SearchOutlinedIcon/>

                    <input
                        type="text"
                        placeholder="Year"
                        value={search.queryYear}
                        onChange={(e) => dispatch(setField({name: "queryYear", value: e.target.value}))}
                    />
                </div>

                <div className="search">
                    <input
                        type="date"
                        // onChange={handleStartChange}
                        onChange={(e) =>
                            dispatch(setField({name: "startDate", value: e.target.value}))
                        }
                        style={{
                            padding: "8px 12px",
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                        }}/>--

                    <input
                        type="date"
                        onChange={(e) =>
                            dispatch(setField({name: "endDate", value: e.target.value}))
                        }
                        style={{
                            padding: "8px 12px",
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                        }}/>
                </div>

                <div className="search">
                    <select id="order" onChange={(e) =>
                        dispatch(setField({name: "order", value: e.target.value}))
                    }>
                        <option value="DESC">DESC</option>
                        <option value="ASC">ASC</option>
                    </select>
                    <select id="region_id" onChange={handleSelectRegionID}>
                        <option value="">Pilih Region Id</option>
                        {regions.map((reg) => (
                          <option key={reg.id} value={reg.id}>
                            {reg.id}
                          </option>
                        ))}
                    </select>
                </div>
                <div className="search">
                    <button onClick={() => dispatch(resetFilters())} className="reset">
                        Reset
                    </button>
                </div>
                <div className="search">

                </div>


            </div>

            {/* DATAGRID */}
            <DataGrid
                className="datagrid"
                columns={columns.concat(actionColumn)}
                components={{
                Toolbar: GridToolbar
            }}
                autoHeight
                rows={search.data}
                rowCount={search.total}
                loading={search.loading}
                pagination
                paginationMode="server"
                rowsPerPageOptions={[10, 30, 50, 70, 100]}
                page={search.page - 1}
                pageSize={search.pageSize}
                onPageChange={(page) => dispatch(setPage(page + 1))}
                onPageSizeChange={(size) => dispatch(setPageSize(size))}
            />
        </div>
    );
};

export default DatatableTicketSite;
